export const routes = (prefix = `pharmacy`) => [
    {
        path: `/${prefix}/dashboard`,
        name: `${prefix}.dashboard`,
        component: () => import('./queue/Index.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName: `${prefix}.dashboard`,
                PageDescription: "Pharmacy - Queue",
            },
        },
    },
    {
        path: `/${prefix}/prescription-history`,
        name: `${prefix}.prescription-history`,
        component: () => import('./queue/prints/IssueHistory.vue'),
        meta: {
            requiresAuth: false,
            permissions: {
                PageName: `${prefix}.dashboard`,
                PageDescription: "Pharmacy - Queue",
            },
        },
    },
];
